'use es6';

export const CANVAS_INLINE = 'canvasinline';
export const CANVAS_IFRAME = 'canvasiframe';